export default __webpack_public_path__ + "static/media/riza-large-logo-no-text.dd3975e4.svg";